;(function (W, $, D) {

  'use strict'

  if (typeof W.sg === 'undefined') {
    W.sg = {}
  }

  let sg = W.sg, $D = $(D), $root = $('.paragraph--type--contacts')
  const oUtils = sg.utils

  let contacts = (() => {

    /**
     * @function toggleContact
     * Show/hide contact informations
     */
    let toggleContact = () => {
      $root.find('.toggle-button').on('click', (e) => {
        let $btn = $(e.currentTarget),
            $mailWrapper = $btn.siblings('.mail-wrapper'),
            $infosWrapper = $btn.parents('.content').find('.infos-wrapper')

        oUtils.toggleAriaExpanded($btn)

        $mailWrapper.slideToggle()
        $infosWrapper.slideToggle()
      })
    },

    oMod = {
      toggleContact: toggleContact
    }

    return oMod
  })()

  $D.ready(function () {
    contacts.toggleContact()
  })
  
})(window, window.jQuery, document)
